import React from 'react';
import { Clock, CalendarDays } from 'lucide-react';

export function PopularTimes({ popularHours, popularDays }) {
  const maxHourCount = Math.max(...(popularHours || []).map(h => h.count), 1);
  const maxDayCount = Math.max(...(popularDays || []).map(d => d.count), 1);
  const hasData = (popularHours && popularHours.length > 0) || (popularDays && popularDays.some(d => d.count > 0));

  if (!hasData) {
    return (
      <div className="card-surface p-6" data-testid="popular-times">
        <h3 className="font-heading text-base font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
          <Clock className="h-4 w-4 text-[#D4AF37]" />
          Popular Booking Times
        </h3>
        <p className="text-sm text-stone-400 text-center py-6">No booking time data for this period.</p>
      </div>
    );
  }

  return (
    <div className="card-surface p-6" data-testid="popular-times">
      <h3 className="font-heading text-base font-medium text-[#1A1A1A] mb-5 flex items-center gap-2">
        <Clock className="h-4 w-4 text-[#D4AF37]" />
        Popular Booking Times
      </h3>

      {/* Hour distribution */}
      {popularHours && popularHours.length > 0 && (
        <div className="mb-5">
          <p className="text-xs text-stone-500 uppercase tracking-wider mb-3">By Time of Day</p>
          <div className="flex items-end gap-1 h-24" data-testid="popular-hours-chart">
            {popularHours.map((h) => {
              const pct = (h.count / maxHourCount) * 100;
              const intensity = Math.max(pct / 100, 0.15);
              return (
                <div key={h.hour} className="flex-1 flex flex-col items-center gap-1 min-w-0" title={`${h.hour}: ${h.count} bookings`}>
                  <div
                    className="w-full rounded-t transition-all duration-500"
                    style={{
                      height: `${Math.max(pct, 6)}%`,
                      backgroundColor: `rgba(212, 175, 55, ${intensity})`,
                      border: pct > 50 ? '1px solid rgba(212, 175, 55, 0.4)' : 'none'
                    }}
                  />
                  <span className="text-[9px] text-stone-400 leading-none truncate w-full text-center">
                    {h.hour.replace(':00', '')}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Day distribution */}
      {popularDays && popularDays.some(d => d.count > 0) && (
        <div>
          <p className="text-xs text-stone-500 uppercase tracking-wider mb-3 flex items-center gap-1.5">
            <CalendarDays className="h-3 w-3" />
            By Day of Week
          </p>
          <div className="space-y-1.5" data-testid="popular-days-chart">
            {popularDays.map((d) => {
              const pct = maxDayCount > 0 ? (d.count / maxDayCount) * 100 : 0;
              return (
                <div key={d.day} className="flex items-center gap-2">
                  <span className="text-xs text-stone-500 w-8 text-right">{d.day.slice(0, 3)}</span>
                  <div className="flex-1 h-5 bg-[#F9F6F0] rounded overflow-hidden">
                    <div
                      className="h-full rounded transition-all duration-500"
                      style={{
                        width: `${Math.max(pct, 2)}%`,
                        background: pct > 60
                          ? 'linear-gradient(90deg, #D4AF37, #c9a030)'
                          : '#D4AF37'
                      }}
                    />
                  </div>
                  <span className="text-xs text-stone-500 w-6 text-right font-mono">{d.count}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
